// extracted by mini-css-extract-plugin
module.exports = {"banner":"FreshGRLCBanner_banner__GV84b","subdomain":"FreshGRLCBanner_subdomain__PJy6_","subtext":"FreshGRLCBanner_subtext___Qo5E"};